import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { EmailHubService } from 'src/app/private/services/email-hub.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-mail-left-actions',
  imports: [SharedModule],
  templateUrl: './mail-left-actions.component.html',
  styleUrl: './mail-left-actions.component.scss'
})
export class MailLeftActionsComponent {

  isSmallScreen = false;

  @Input() activeAction: string = 'inbox';
  @Output() actionChange = new EventEmitter<string>();
  @Output() refresh = new EventEmitter<void>();
  @Output() isCompose = new EventEmitter<void>();
  @Input() updateDraft = false;
  btnLoading = false;
  @Input() isAccountNotConnected: boolean = false;

  openRevokeAccessModal = false;


  actions = [
    {
      label: 'Inbox',
      icon: 'inbox',
      action: 'inbox'
    },
    {
      label: 'Sent',
      icon: 'paper-plane',
      action: 'sent'
    },
    {
      label: 'Drafts',
      icon: 'file-alt',
      action: 'drafts'
    },
    {
      label: 'Junk',
      icon: 'archive',
      action: 'trash'
    },
    {
      label: 'Deleted',
      icon: 'trash',
      action: 'deleted'
    }
  ]

  constructor(
    // private breakpointObserver: BreakpointObserver,
    // private bottomSheet: MatBottomSheet,
    // private toast: ToastrService,
    private api: EmailHubService,
    private localStorage: LocalStorageService,
    private  messageService: MessageService
    // private modalService: NgbModal
  ) { }

  // ngOnInit() {
  //   this.breakpointObserver.observe(['(max-width: 780px)']).subscribe((result) => {
  //     this.isSmallScreen = result.matches;
  //   });
  // }

  showRevokeDialog = false;
  showComposeSheet = false;

  handlOpenRevokeAccessModal() {
    this.showRevokeDialog = true;
  }

  closeRevokeDialog() {
    this.showRevokeDialog = false;
  }

  // Helper method to convert FontAwesome icons to PrimeIcons
  getPrimeIcon(fontAwesome: string): string {
    const iconMap: { [key: string]: string } = {
      'inbox': 'inbox',
      'paper-plane': 'send',
      'file-alt': 'file-edit',
      'trash': 'trash',
      'archive': 'times-circle'
    };
    return iconMap[fontAwesome] || 'circle';
  }

  setActiveAction(action: string) {
    this.actionChange.emit(action);
  }

  reloadData() {
    this.refresh.emit();
  }

  openBottomSheet(): void {
    this.isCompose.emit();
  }

  // handlOpenRevokeAccessModal(content: any) {
  //   this.openRevokeAccessModal = true;
  //   // this.modalService.open(content, {
  //   //   size: 'l',
  //   //   scrollable: true,
  //   //   centered: true,
  //   // });
  // }


  confirmRevokeAccess() {
    const payload = {
      email: this.localStorage.getEmail(),
      organization_id: this.localStorage.getOrganizationId(),
      user_id: this.localStorage.getUserId()
    };
    this.btnLoading = true;
    this.api.revokeAccess(payload).subscribe({
      next: (res) => {
        this.btnLoading = false;
        this.localStorage.setDefaultEmailCommunicationMode('none');
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Access revoked successfully' });
        window.location.reload();
      },
      error: (e) => {
        this.btnLoading = false;
        console.error(e);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to revoke access' });
        // this.toast.error('Error revoking access');
      }
    });
  }

}
